module.exports = __webpack_public_path__ + "static/media/sopt26ru.45b15f72.pdf";